export default __webpack_public_path__ + "static/media/developer.8cf38314.svg";